import { useAuthState } from "react-firebase-hooks/auth"

import { auth } from "@cs/lib/firebase/firebaseConfig"

export function useUser() {
  const [user, loading] = useAuthState(auth)

  return { user, loading }
}
